import { ProductMapper } from "@omni/mappers/product/product.mapper";
import { ProductTileLayout } from "@omni/ui/brand/product/productTile/productTile.config";
import { useMapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";
import { useRef } from "react";

import { ProductSearchTileRenditions } from "@/components/Product/ProductImage/mappedRenditions";
import { ProductTile } from "@/components/Product/ProductTile/productTile.container";
import { AutocompleteItem } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/AutocompleteItem/autocompleteItem";
import { useResults } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/context/results.context";
import { PRODUCTS_SOURCE_ID } from "@/components/Search/SearchBar/config/searchBar.config";
import { useSearchBarContext } from "@/components/Search/SearchBar/context/searchBar.context";
import * as AlgoliaTrackingService from "@/services/algolia/algoliaTracking.service";

type Props = {
    className?: string;
};

export const Item = ({ className }: Props) => {
    const { items } = useResults(PRODUCTS_SOURCE_ID);
    const { autocompleteState, autocompleteActions } = useSearchBarContext();
    const { index } = useMapped();

    const item = items[index];

    const productTileItem =
        ProductMapper.fromAlgoliaSearchAutocompleteToProductTile(item);
    const ref = useRef<HTMLAnchorElement | null>(null);

    const trackClick = () => {
        if (!item.__autocomplete_queryID || !item.__autocomplete_id) return;

        AlgoliaTrackingService.trackQuery(
            item.__autocomplete_queryID,
            item.sku,
            item.__autocomplete_id
        );
    };

    const handleAutocompleteItemSubmit = () => {
        trackClick();
        ref.current?.click();
    };

    return (
        <AutocompleteItem
            className={cn(
                "tw:bg-white! tw:p-0! tw:overflow-visible tw:flex tw:flex-col",
                className
            )}
            itemId={item.__autocomplete_id}
            onSubmit={handleAutocompleteItemSubmit}
            autocompleteState={autocompleteState}
            autocompleteActions={autocompleteActions}
        >
            <ProductTile
                ref={ref}
                sku={item.sku}
                product={productTileItem}
                allowInstantAddToCart={false}
                productTileConfig={{
                    border: true,
                    amountOfFeatures: 0,
                    imageRenditions: ProductSearchTileRenditions,
                    components: ProductTileLayout.SEARCH(),
                    hoverEffect: true
                }}
                onClickTrack={trackClick}
            />
        </AutocompleteItem>
    );
};
